<div class="uk-flex uk-flex-center">
    <div class="uk-container">
        <div class="uk-card uk-card-default uk-border-rounded uk-overflow-hidden">
            <div class="uk-grid-collapse" uk-grid uk-height-match="row:false;">
                <div class="uk-width-1-4@s uk-background-cover" data-src="assets/images/bg-cal-insure.svg" uk-img></div>
                <div class="uk-width-3-4@s uk-padding-small">
                    <div class="uk-flex uk-flex-middle uk-text-center">
                        <div>
                            <h2 class="uk-margin-medium-bottom uk-text-left">เครื่องมือในการคำนวณหาประกันแบบที่ใช่ เพื่อให้เหมาะกับคุณ</h2>
                            <a routerLink="/calculate"
                                class="uk-button uk-button-default uk-border-rounded">ค้นหาแบบประกันที่ใช่</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>